export default __webpack_public_path__ + "static/media/puppet-samurai-art.9cd5b5ad.png";